module.exports = __webpack_public_path__ + "img/lipachat.0350557b.png";